import { Helmet } from 'react-helmet-async';
import AccountNewView from 'src/sections/taikhoan/view/account-new-view';
// sections

// ----------------------------------------------------------------------

export default function AccountNewPage() {
  return (
    <>
      <Helmet>
        <title> Quản trị:Tạo mới tài khoản</title>
      </Helmet>

      <AccountNewView />
    </>
  );
}
